type RedirectTarget = Pick<Location, 'assign'>;

export function hardRedirect(
  path: string,
  target: RedirectTarget = window.location,
) {
  target.assign(path);
}
